<app-navbar></app-navbar>
<div class="page-title-area" style="height: 60px !important"></div>
<section class="" style="padding: 20px 0px 40px 0px; font-family: 'Congenial'">
    <div class="container" style="background: transparent">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div
                    class="blog-details-desc"
                    style="
                        background-size: 100px;
                        padding: 20px;
                        padding-top: 10px;
                        padding-bottom: 10px;
                        border: 1px solid #eeeeee;
                    "
                >
                    <div class="article-image">
                        <h1 style="font-weight: normal; text-align: center; color: white;">
                          Volunteer Information
                        </h1>
                    </div>
                </div>
                <ng-container *ngIf="all_employee_data != null">
                    <!-- Dynamic Ok -->
                    <div class="bg-image">
                        <div
                            class="container"
                            style="padding-top: 30px; padding-bottom: 30px"
                        >
                            <div class="row">
                                <div class="col-md-12">
                                    <div style="min-height: 800px">
                                        <div
                                            *ngFor="
                                                let item of paginated_teachers_info
                                            "
                                            class="blog-details-desc"
                                            style="
                                                padding: 20px;
                                                border: 1px solid #eeeeee;
                                                margin: 15px 0px;
                                                box-shadow: 2px 4px 13px 1px grey; color: white;
                                            "
                                        >
                                            <div class="container">
                                                <div
                                                    class="row align-items-center"
                                                >
                                                    <div
                                                        class="col-lg-4 col-md-12"
                                                    >
                                                        <div
                                                            class="about-image"
                                                        >
                                                            <img
                                                                [src]="
                                                                    item.ImageLink
                                                                "
                                                                alt="image"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="col-lg-8 col-md-12"
                                                    >
                                                        <div>
                                                            <h3 style="color: white;" class="elip">
                                                                {{
                                                                    item.EmployeeName
                                                                }}
                                                            </h3>
                                                            <p style="color: white;"class="elip">
                                                                Designation:
                                                                {{
                                                                    item.Designation
                                                                }}
                                                            </p>
                                                            <p style="color: white;" class="elip">
                                                                EmployeeId:
                                                                {{
                                                                    item.EmployeeId
                                                                }}
                                                            </p>
                                                            <p style="color: white;" class="elip">
                                                                JoiningDate:
                                                                {{
                                                                    item.JoiningDate
                                                                        | date
                                                                            : "yyyy-MM-dd"
                                                                }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="pagination">
                                            <button
                                                (click)="
                                                    onPageChange(pageIndex - 1)
                                                "
                                                [disabled]="pageIndex === 0"
                                            >
                                                Previous
                                            </button>

                                            <button
                                                *ngFor="
                                                    let page of totalPages;
                                                    let i = index
                                                "
                                                (click)="onPageChange(i)"
                                                [class.active]="pageIndex === i"
                                            >
                                                {{ page }}
                                            </button>

                                            <button
                                                (click)="
                                                    onPageChange(pageIndex + 1)
                                                "
                                                [disabled]="
                                                    pageIndex + 1 >=
                                                    totalPages.length
                                                "
                                            >
                                                Next
                                            </button>
                                        </div>

                                        <div *ngIf="all_teachers_info == null">
                                            <div
                                                class="page-title-content"
                                                style="
                                                    margin-top: 100px;
                                                    margin-bottom: 100px;
                                                "
                                            >
                                                <h2>No Data Found</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Dynamic Ends -->
                </ng-container>
            </div>
            <!-- <div class="col-lg-4">
                <app-aside></app-aside>
            </div> -->
        </div>
    </div>
</section>
